import {Field} from 'formik';

import {
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Container} from "@mantine/core";


export const FormComponent = () => {

    return (
        <Container>
            <PlatformFieldset legend={'Product Feature'}>
                <Field
                    name='name'
                    label='Feature Name'
                    description='Please enter the feature name'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='category'
                    label='Category'
                    description='Please enter the feature category'
                    component={FormikTextInput}
                    my={'xl'}
                />

            </PlatformFieldset>

            <PlatformFieldset legend={'Description'}>
                <Field
                    name='description'
                    label='Description'
                    description='Please enter feature description'
                    component={FormikTextarea}
                    my={'xl'}
                />
            </PlatformFieldset>


        </Container>
    );
};
